import ReLoading from 'utils/vue/components/elements/re-loading'
import ReModal from 'utils/vue/components/modals/re-modal'
import ReCheckbox from 'utils/vue/components/basic/form/re-checkbox'
import ReInput from 'utils/vue/components/basic/form/re-input'
import ReTextarea from 'utils/vue/components/basic/form/re-textarea'
import ReSelect from 'utils/vue/components/basic/form/re-select'
import ReSelect2 from 'utils/vue/components/basic/form/re-select2'
import ReButton from 'utils/vue/components/basic/buttons/re-button'
import VButton from 'utils/vue/components/basic/buttons/Button'

export default {
    ReLoading,
    ReModal,
    ReCheckbox,
    ReInput,
    ReTextarea,
    ReSelect,
    ReSelect2,
    ReButton,
    VButton,
}
